import React, { useState } from "react";
import TextInput from "../../../../components/textInput";
import AlertDialog from "../../../../components/alertDialog";
import i18n from "~/i18n";

export default function DeleteInboxDialog({
  inbox,
  isOpen,
  onSubmit,
  ...rest
}) {
  const [deleteInboxName, setDeleteInboxName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState(false);

  async function handleSubmit() {
    setSubmitting(true);

    try {
      await validateForm();
      await onSubmit(inbox);
    } finally {
      setSubmitting(false);
    }
  }

  async function validateForm() {
    try {
      if (deleteInboxName !== inbox.name) {
        throw i18n.t("chat:settings.general.deleteDialog.invalid")
      }

      setFormErrors(null);
    } catch (error) {
      setFormErrors({ deleteInboxName: error });
      throw error;
    }
  }

  return (
    <AlertDialog
      open={isOpen}
      title={i18n.t("chat:settings.general.deleteDialog.header")}
      description={i18n.t("chat:settings.general.deleteDialog.description", { name: inbox.name })}
      ctaText={i18n.t("chat:settings.general.deleteDialog.confirm")}
      submitting={submitting}
      onCtaClick={handleSubmit}
      {...rest}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <TextInput
          label={i18n.t("chat:settings.general.deleteDialog.name")}
          value={deleteInboxName}
          disabled={submitting}
          // Issue with autofocus when opening dialog from a dropdown https://github.com/radix-ui/primitives/issues/1615
          autoFocus
          required
          onChange={(e) => setDeleteInboxName(e.target.value)}
          error={formErrors?.deleteInboxName}
        />
      </form>
    </AlertDialog>
  );
}
